module.exports = __webpack_public_path__ + "img/symbol_3.e7fc6045.png";